import { FC } from 'react'
import styles from 'components/features/pfm/PremiumOnly/PremiumOnly.styl'
import { PremiumOnlyIcon } from 'components/features/pfm/PremiumOnlyIcon/PremiumOnlyIcon'

type PremiumOnlyProps = {
  isBlocked: boolean
}

export const PremiumOnly: FC<PremiumOnlyProps> = (props) => {
  const { children, isBlocked } = props

  return (
    <div className={ styles.premiumOnly }>
      <div className={ styles.content }>
        { children }
      </div>
      <PremiumOnlyIcon isBlocked={ isBlocked } />
    </div>
  )
}
